import { render, staticRenderFns } from "./organizationDetail.vue?vue&type=template&id=bbca2754&scoped=true"
import script from "./organizationDetail.vue?vue&type=script&lang=js"
export * from "./organizationDetail.vue?vue&type=script&lang=js"
import style0 from "./organizationDetail.vue?vue&type=style&index=0&id=bbca2754&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbca2754",
  null
  
)

export default component.exports